export const GAME_WIDTH_DEFAULT = 1680; // 1320 // 1680; // 3580;
export const GAME_HEIGHT_DEFAULT = 720; // 720; // 1536;
export const GAME_SAFE_WIDTH = 960; // 1024;
export const GAME_SAFE_HEIGHT = 720;
export const GAME_BACKGROUND_COLOR = '0xFFFFFF';

export const DECODE_TIMEOUT_SPEED = 3000; // time before it says 'Loading' instead of 'Loading 100%'

export const GAME_DIV_ID = 'gameContent';
export const GAME_DIV_CLASSNAME = 'canvas_container absolute_center page_background trap';
export const SAVED_PLAYER_DATA_ID = 'ewwnature'; // TODO : Move to app config??
export const SAVED_PLAYER_DATA_PREFIX = 'playersave_'; // TODO : Move to app config??

export const PATH_BASE = './';
export const PATH_ASSETS = 'assets/';

export const FONT_BOLD = 'Elinor';
export const FONT_BOLD_ITALIC = 'Elinor';
export const FONT_EXTRA_BOLD = 'Elinor';
export const FONT_REGULAR = 'Elinor';
export const FONT_LIGHT = 'Elinor';
export const FONT_ITALIC = 'Elinor';
export const FONT_CSS = 'stylesheet.css';

export const FONT_TITLE = FONT_BOLD;
export const FONT_COPY = FONT_REGULAR;
export const FONT_COPY_CSS = FONT_CSS;
export const FONT_SUBTITLE = FONT_LIGHT;
export const FONT_SUBTITLE_CSS = FONT_CSS;
export const FONT_SUBTITLE_SIZE = '32';

export const NIGHT_TINT = 0x958ac1;
export const TIME_DAY = 'day';
export const TIME_NIGHT = 'night';
export const TAP_LIMIT = 8;
